<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YkQk5X/tc-custom/9781617451331.jpg?1700300454280" alt="This image is the cover for the book Foolproof Crazy-Quilt Projects"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Foolproof Crazy-Quilt Projects
      </h1>
      <p class="bookDescription body article font2">
        <b>“Detailed how-to’s (and images) for embroidery, beading and embellishing stitches, including silk ribbon―a must-have book for every crazy-quilter’s library!” —<i>Quilter’s Connection</i></b><br/>  <br/> Embrace the versatility of crazy quilting with quick-to-sew projects! In a follow-up to the bestselling <i>Foolproof Crazy Quilting</i>, Jennifer Clouston shares ten small, useful items from a tablet purse and summer slippers to a tea cozy, each with links to full-size patterns. Expertly mix cotton, wool, linen, and silk for eclectic fabric pairings that complement each project.<br/>  <br/> Both beginning and experienced crazy quilters will also love the dictionary of sixty embroidery and beading stitches, foundation piecing primer, and stitch maps for all seam treatments and embellishments.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Clouston
      </h2>
      
      <p class="authorDescription body article">Jennifer Clouston started quilting after the birth of her first child. Now that her kids have flown the nest, she keeps busy teaching quilting and writing. The author of Foolproof Crazy Quilting, she and her husband live in Australia. jenniferclouston.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68b9ea98